import React from 'react';
import './Testimonial.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Testimonial = () => {
const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Marketing Head, Flipkart",
    content: "Our organic traffic grew by 300% after implementing their SEO strategies. Their understanding of the Indian e-commerce landscape is exceptional.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/33.jpg"
  },
  {
    id: 2,
    name: "Rahul Patel",
    role: "CEO, Zomato",
    content: "The local SEO techniques they implemented helped our restaurant partners gain 40% more visibility in search results across India.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/22.jpg"
  },
  {
    id: 3,
    name: "Ananya Reddy",
    role: "Digital Manager, MakeMyTrip",
    content: "Their multilingual SEO approach boosted our international bookings by 65%. Truly a game-changer for our travel business!",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/women/45.jpg"
  },
  {
    id: 4,
    name: "Vikram Singh",
    role: "Founder, Paytm",
    content: "Their technical SEO audit identified critical issues we had missed. Our mobile app installs increased by 55% post-optimization.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/41.jpg"
  },
  {
    id: 5,
    name: "Neha Gupta",
    role: "E-commerce Director, Myntra",
    content: "The product page optimizations led to a 28% increase in conversions. Their fashion industry expertise is unmatched.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/51.jpg"
  },
  {
    id: 6,
    name: "Arjun Mehta",
    role: "CTO, Swiggy",
    content: "Their schema markup implementation improved our rich snippets appearance by 80%. Food delivery orders saw significant growth.",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/men/36.jpg"
  },
  {
    id: 7,
    name: "Divya Iyer",
    role: "SEO Manager, Ola Cabs",
    content: "The location-based SEO strategy increased our bookings from tier-2 cities by 45%. Excellent understanding of Indian demographics.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/62.jpg"
  },
  {
    id: 8,
    name: "Rohan Malhotra",
    role: "Director, BYJU'S",
    content: "Their content optimization for educational keywords boosted our organic sign-ups by 60% during the pandemic.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/55.jpg"
  },{
    id: 9,
    name: "Rajesh Deshpande",
    role: "Owner, Pune Food Delights",
    content: "Our small restaurant in Pune saw a 200% increase in online orders after their local SEO optimization. Fantastic results for our Marathi cuisine business!",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/65.jpg"
  },
  {
    id: 10,
    name: "Sunita Kulkarni",
    role: "Director, Mumbai Fashion Hub",
    content: "As a boutique in Colaba, we now rank #1 for 'designer sarees Mumbai' thanks to their hyperlocal SEO strategy. Walk-ins increased by 75%.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/68.jpg"
  },
  {
    id: 11,
    name: "Vijay More",
    role: "CEO, Nashik Wine Tours",
    content: "Our wine tourism business got 3x more bookings after they optimized our website for Maharashtra travel keywords. Dhanyavaad!",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/men/70.jpg"
  },
  {
    id: 12,
    name: "Aarti Joshi",
    role: "Founder, Kolhapuri Chappal Co.",
    content: "From a small workshop to now selling across India - their e-commerce SEO transformed our traditional Maharashtrian footwear business.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/72.jpg"
  },
  {
    id: 13,
    name: "Sanjay Pawar",
    role: "Manager, Konkan Sea Foods",
    content: "Our Ratnagiri seafood export business website now ranks for both Marathi and English keywords. Orders from overseas increased significantly.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/75.jpg"
  },
  {
    id: 14,
    name: "Meena Thakur",
    role: "Owner, Aurangabad Heritage Tours",
    content: "They helped our small tour company dominate 'Ajanta Ellora tours' searches. Now getting 15+ bookings daily from their SEO efforts.",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/women/75.jpg"
  },
  {
    id: 15,
    name: "Aditya Bapat",
    role: "Owner, Kayani Bakery (Pune)",
    content: "Our legendary Shrewsbury biscuits now get 50% more online orders since they optimized our website for 'Pune famous bakery' searches.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/76.jpg"
  },
  {
    id: 16,
    name: "Rucha Vaidya",
    role: "CEO, Hotel Panchali (Mahabaleshwar)",
    content: "Room bookings increased by 120% after they improved our visibility for 'Mahabaleshwar hill station stays' and related keywords.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/76.jpg"
  },

  // Manufacturing & Textiles
  {
    id: 17,
    name: "Dinesh Chavan",
    role: "MD, Solapur Textile Mills",
    content: "Our wholesale enquiries tripled after SEO optimization for 'Solapur bedsheets manufacturers' and other industrial keywords.",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/men/77.jpg"
  },
  {
    id: 18,
    name: "Pooja Ghorpade",
    role: "Director, Ichalkaranji Powerloom Cluster",
    content: "They helped our cooperative rank for technical textile terms, resulting in 40% more export enquiries from Western countries.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/77.jpg"
  },

  // Healthcare & Wellness
  {
    id: 19,
    name: "Dr. Aniruddha Desai",
    role: "Chief Surgeon, Sahyadri Hospitals",
    content: "Our specialty treatments page now ranks #1 for 'cardiac care Pune', bringing 30% more patient enquiries monthly.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/78.jpg"
  },
  {
    id: 20,
    name: "Shalini Rane",
    role: "Owner, Kaivalyadhama Yoga Center",
    content: "Their content strategy made us the top result for 'yoga retreats near Mumbai'. Retreat bookings up by 65%.",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/women/78.jpg"
  },

  // Education & Training
  {
    id: 21,
    name: "Prof. Vikas Kulkarni",
    role: "Principal, Fergusson College",
    content: "Our online course admissions increased by 80% after they optimized our pages for 'best arts college in Pune' searches.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/79.jpg"
  },
  {
    id: 22,
    name: "Nandini Joshi",
    role: "Director, IIT Mumbai Coaching Classes",
    content: "Now ranking #1 for 'JEE preparation Mumbai' - our classroom occupancy reached 100% within 3 months of SEO work.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/women/79.jpg"
  },

  // Real Estate
  {
    id: 23,
    name: "Rajiv Oswal",
    role: "CEO, Marvel Realtors (Pune)",
    content: "Property enquiries increased by 150% after local SEO for '2BHK flats in Wakad' and other micro-market terms.",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/men/80.jpg"
  },
  {
    id: 24,
    name: "Mihir Gadre",
    role: "MD, Konkan Development Corporation",
    content: "Our Alibag weekend homes project sold out within months after improved search visibility for 'sea facing villas near Mumbai'.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/81.jpg"
  },

  // Automotive
  {
    id: 25,
    name: "Sanjay Rane",
    role: "Dealer Principal, Pratham Motors (Nashik)",
    content: "Car test drive requests doubled after optimizing for 'Tata showroom Nashik' and other location-specific terms.",
    rating: 5,
    // avatar: "https://randomuser.me/api/portraits/men/82.jpg"
  },
  {
    id: 26,
    name: "Aruna Patil",
    role: "Owner, Auto Parts Waluj (Aurangabad)",
    content: "Our wholesale auto components business saw 90% more enquiries from other states after their industrial SEO strategy.",
    rating: 4,
    // avatar: "https://randomuser.me/api/portraits/women/80.jpg"
  },
  {
  id: 27,
  name: "Dr. Anjali Mishra",
  role: "Principal, Delhi Public School Aurangabad",
  content: "Our school website now ranks #1 for 'best CBSE schools in Aurangabad'. Online admission enquiries increased by 70% within 6 months of SEO optimization.",
  rating: 5,
//   avatar: "https://randomuser.me/api/portraits/women/81.jpg"
},
{
  id: 30,
  name: "Mr. Irfan Khan",
  role: "Principal, Maulana Azad School",
  content: "Their multilingual SEO strategy helped us rank for both Urdu and Marathi education keywords. Community engagement improved significantly.",
  rating: 4,
//   avatar: "https://randomuser.me/api/portraits/men/84.jpg"
},
{
  id: 32,
  name: "Mr. Rajiv Menon",
  role: "Chairman, Cambridge School",
  content: "Now appearing in 'top 10 IGCSE schools Maharashtra' searches. Our website traffic increased 3x, attracting NRI families to our campus.",
  rating: 5,
//   avatar: "https://randomuser.me/api/portraits/men/85.jpg"
}
];

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>★</span>
    ));
  };
    const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
        <section className="testimonial-section">
      <div className="container">
        <h2 className="section-title-testimonial">What Our Clients Say</h2>
        <p className="section-subtitle">Trusted by businesses worldwide to improve their search visibility</p>
        <Slider {...settings}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id}>
              <div className="testimonial-card">
                <div className="rating">{renderStars(testimonial.rating)}</div>
                <p className="testimonial-content">"{testimonial.content}"</p>
                <div className="client-info">
                  {/* <img src={testimonial.avatar} alt={testimonial.name} className="client-avatar" /> */}
                  <div>
                    <h4 className="client-name">{testimonial.name}</h4>
                    <p className="client-role">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;